import { lazy, Suspense, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useRegisterSW } from "virtual:pwa-register/react";

import { useAuth } from "./auth";
import { AppShell } from "./components/AppShell";
import { AssessmentPage } from "./pages/AssessmentPage";
import { AuthPage } from "./pages/AuthPage";
import { BookPage } from "./pages/BookPage";
import { DashboardPage } from "./pages/DashboardPage";
import { InboxPage } from "./pages/InboxPage";
import { LibraryPage } from "./pages/LibraryPage";
import { VocabularyPage } from "./pages/VocabularyPage";

const ReaderPage = lazy(() =>
  import("./pages/ReaderPage").then((module) => ({ default: module.ReaderPage }))
);

function UpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker
  } = useRegisterSW();
  if (!needRefresh) return null;
  return (
    <button className="update-toast" onClick={() => void updateServiceWorker(true)}>
      新版本已准备好 · 点击更新
    </button>
  );
}

function ProtectedApp() {
  const { user } = useAuth();
  useEffect(() => {
    document.documentElement.dataset.authenticated = String(Boolean(user));
  }, [user]);
  if (!user) return <Navigate to="/auth" replace />;
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/assessment" element={<AssessmentPage />} />
        <Route path="/books/:bookId" element={<BookPage />} />
        <Route
          path="/read/:bookId"
          element={
            <Suspense fallback={<div className="state-card">正在打开阅读器</div>}>
              <ReaderPage />
            </Suspense>
          }
        />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/vocabulary" element={<VocabularyPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}

export function App() {
  const { user } = useAuth();
  return (
    <>
      <Routes>
        <Route path="/auth" element={user ? <Navigate to="/" replace /> : <AuthPage />} />
        <Route path="*" element={<ProtectedApp />} />
      </Routes>
      <UpdatePrompt />
    </>
  );
}
